import { Component } from '@angular/core';

@Component({
  selector: 'ad-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerAtom {}
